import { jsx as e } from "react/jsx-runtime";
import { Toaster as t } from "sonner";
import { useTheme as a } from "next-themes";
var l = ({ ...r }) => {
  const { theme: o = "system" } = a();
  return /* @__PURE__ */ e(t, {
    className: "lib:toaster lib:group",
    style: {
      "--normal-bg": "var(--popover)",
      "--normal-text": "var(--popover-foreground)",
      "--normal-border": "var(--border)"
    },
    theme: o,
    ...r
  });
};
export {
  l as Toaster
};
